export default function getIntlDateRokuyou() {
    // The "day" (e.g. Senshou) is actually used as a date.  There is no day.
    return '';
}
